// make the whole item clickable
document.querySelectorAll(".data-link").forEach(el => {
  el.addEventListener("click", () => {
    window.location.href = el.dataset.link;
  });
});